"use client";

import React from "react";
import { TrendingUp, Users, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefitsData = [{
  icon: TrendingUp,
  title: "Boost Your Revenue",
  description: "Earn a steady stream of additional income with every powerbank rented from your location, with zero upfront investment."
}, {
  icon: Users,
  title: "Increase Foot Traffic",
  description: "Attract new customers who need a quick charge and encourage them to stay longer and spend more at your venue."
}, {
  icon: Zap,
  title: "Zero Maintenance",
  description: "We provide the modern charging station, handle all technical support, and manage the rentals. You just plug it in."
}];
export default function Benefits() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="benefits" className="bg-background py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-2xl text-center transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-base/7 font-semibold text-primary tracking-wide uppercase">
            Partnership Benefits
          </h2>
          <p className="mt-2 text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
            Why Partner With ZapGO!?
          </p>
          <p className="mt-6 text-lg/8 text-muted-foreground">
            Transform a small space into a new revenue stream. Join our network of venues and offer a valuable service to your customers.
          </p>
        </div>

        <div ref={gridRef} className={`mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {benefitsData.map((benefit, i) => {
            const Icon = benefit.icon;
            return <div key={benefit.title} data-index={i} className="group flex flex-col items-center text-center">
                  <div className="mb-6 flex size-16 items-center justify-center rounded-2xl bg-primary/10 text-primary transition-all duration-500 ease-out group-hover:bg-primary/20 group-hover:shadow-[0_0_30px_-5px_var(--color-primary)] group-hover:scale-110">
                    <Icon className="size-8" aria-hidden="true" strokeWidth={1.5} />
                  </div>
                  <div className="transition-transform duration-500 ease-out group-hover:-translate-y-2">
                    <h3 className="text-xl font-semibold leading-7 text-foreground">
                      {benefit.title}
                    </h3>
                    <p className="mt-4 text-base leading-7 text-muted-foreground">
                      {benefit.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}